import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { ThemeConfig } from '../../../assets/data/enum/themeConfig';
import { AuthenticationService } from '../../common/_services';
import { ThemeService } from '../../common/_theme/theme.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-public-chat-support',
  templateUrl: './public-chat-support.component.html',
  styleUrls: ['./public-chat-support.component.css'],
  standalone: false,
})
export class PublicChatSupportComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription = new Subscription();
  urlForChat: string;
  isActive = false;
  baseUrlForChat: string;
  urlSafe: SafeResourceUrl;
  isLoggedIn$: Observable<boolean>;
  blockReloadChat = false;

  constructor(
    public sanitizer: DomSanitizer,
    private translate: TranslateService,
    private authenticationService: AuthenticationService,
    private themeService: ThemeService
  ) {
    this.themeService.getVersion().subscribe((data) => {
      const environmentVersion = data.version;
      this.themeService.setVersionInLocalStorage(environmentVersion);
      this.isLoggedIn$ = this.authenticationService.isLoggedIn;
      const lng = this.translate.currentLang.toString();
      const onlyVersion = environmentVersion.split('|')[0].trim();
      if (ThemeConfig.chatServiceProvider == 'slack') {
        this.baseUrlForChat =
          environment.chatSlackUrlSrevice +
          '&v=' +
          onlyVersion +
          '&ct=WebAPP' +
          '&f=' +
          ThemeConfig.brand.toLowerCase() +
          '&lang=' +
          lng +
          '&url=' +
          window.location.href;
      } else if (ThemeConfig.chatServiceProvider == 'salesforce') {
        this.baseUrlForChat =
          environment.chatSFUrlSrevice +
          '?v=' +
          onlyVersion +
          '&ct=WebAPP' +
          '&f=' +
          ThemeConfig.brand.toLowerCase() +
          '&lang=' +
          lng +
          '&url=' +
          window.location.href;
      }
    });
  }

  ngOnInit(): void {}

  loadData() {
    this.urlForChat = this.baseUrlForChat + '&l=false';
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlForChat);
    this.blockReloadChat = true;
  }
  openChat() {
    this.isActive = !this.isActive;
    if (this.isActive) {
      this.loadData();
    } else {
      this.ngOnDestroy();
    }
  }

  closeChat() {
    this.isActive = false;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
